import { render, staticRenderFns } from "./FirmList.vue?vue&type=template&id=71698f3c&"
import script from "./FirmList.vue?vue&type=script&lang=ts&"
export * from "./FirmList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports